import { Directive, ElementRef, OnDestroy, OnInit, Renderer2, inject } from '@angular/core';

import { SimpleCallback } from '@frontend/sports/common/core/utils/extended-types';
import { TimerService } from '@frontend/sports/common/core/utils/timer';
import { DeviceService } from '@frontend/vanilla/core';
import { Subscription } from 'rxjs';

@Directive({ selector: '[msScrollIosHack]' })
export class ScrollIosHackDirective implements OnInit, OnDestroy {
    private timerService = inject(TimerService);
    private deviceService = inject(DeviceService);
    private renderer = inject(Renderer2);
    private element = inject(ElementRef);

    private orientationSubscription?: Subscription;
    private timeout?: SimpleCallback;

    ngOnInit(): void {
        if (!this.deviceService.isiOS) {
            return;
        }

        this.orientationSubscription = this.deviceService.orientation.subscribe(() => this.onOrientationChange());
    }

    ngOnDestroy(): void {
        this.orientationSubscription?.unsubscribe();
        this.timeout?.();
    }

    private onOrientationChange() {
        this.changeOverflowScrolling('auto');

        this.timeout = this.timerService.setTimeoutOutsideAngular(() => {
            this.changeOverflowScrolling('touch');
        }, 1000);
    }

    private changeOverflowScrolling(value: string) {
        this.renderer.setStyle(this.element.nativeElement, 'webkitOverflowScrolling', value);
    }
}
